module.exports = __webpack_public_path__ + "static/media/rag_vertical.87849120.mp4";